import styled from 'styled-components';
import createStyles from '@mui/styles/createStyles';

const FormContainer = styled.form`
  width: 100%;
  max-width: 500px;
`;

const Footer = styled.div`
  width: 100%;
`;

const styles = createStyles({
  headlineText: {
    fontSize: 22,
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: 2,
  },

  textField: {
    width: '100%',
    marginBottom: 2,
  },
  button: {
    width: '100%',
  },
  buttonTextTransform: {
    textTransform: 'none',
  },
  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
  },
});

export default styles;
export { FormContainer, Footer };
